import React, { useState, Fragment, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Tooltip, Menu, MenuItem } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import FirstMetaContainer from "./firstMeta";
import { getBGColor } from "../../utils/common";
import {
  selectedCards,
  unselectCard,
  updateBoard,
  updateCardData,
} from "../../redux/actions";
import { toast } from "react-toastify";
import cardService from "../../services/api/cardService";
import {
  getSelectedCardsSelector,
  getCardDetailsByCardIdSelector,
  getBoardDetailsByBoardIdSelector,
} from "../../redux/selectors";
import {
  Container,
  CardFragment,
  CardWrapper,
  CardHeader,
  CardColor,
  CardTitle,
} from "./styles";
import reactionEmojiAdd from "../../assets/images/reaction-emoji-add.svg";
import { REACTION_OPTIONS, emptyReactionSummary } from "../../utils/reactions";

const errorConfig = {
  position: "top-center",
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const CardView = React.memo(
  ({
    cardDetails,
    boardDetails,
    unlink,
    unlinkCard,
    onSelectCards,
    onUnselectCards,
    allSelectedCards,
    select,
    states,
    parentCardBoard,
    onSaveBoardDetails,
    updateCardDetailsAction,
  }) => {
    // initializing states
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const [checkFirstMetaData, setCheckFirstMetaData] = useState(false);

    const [checkSecondMetaData, setCheckSecondMetaData] = useState(false);

    const [openCard, setOpenCard] = useState(false);

    const [isSelected, setIsSelected] = useState(false);
    const [reactionPending, setReactionPending] = useState(false);
    const [reactionMenuAnchorEl, setReactionMenuAnchorEl] = useState(null);

    useEffect(() => {
      if (cardDetails) {
        setCheckFirstMetaData(true);
        //  setCheckSecondMetaData(getSecondSetMetaDataAvailability(cardDetails, boardDetails))
      }
    }, [cardDetails]);

    useEffect(() => {
      if (!allSelectedCards.length) {
        setIsSelected(false);
      }
    }, [allSelectedCards]);

    const stopEvent = (event, url, data) => {
      event.preventDefault();
      event.stopPropagation();
      url = url.replace("{ID}", data.sys_id);
      url = url.replace("{id}", data.sys_id);
      url = url.replace(
        "{type}",
        data.card_type === "Incident" ? "incident" : "sc_task"
      );
      window.open(url, "_blank");
    };

    const getHeader = (card, settings) => (
      <>
        {settings.header_url && settings.header_url !== "" ? (
          <>
            {settings.header_url.indexOf("{id}") >= 0 ? (
              <a
                target="_blank"
                href={settings.header_url
                  .replace("{id}", card.sys_id)
                  .replace(
                    "{type}",
                    card.card_type === "Incident" ? "incident" : "sc_task"
                  )}
                onClick={(e) => stopEvent(e, settings.header_url, card)}
                rel="noreferrer"
              >
                <span>
                  {settings.card_header === "headertext"
                    ? card.header
                    : card.number}
                </span>
              </a>
            ) : (
              <a
                target="_blank"
                href={settings.header_url
                  .replace("{ID}", card.sys_id)
                  .replace(
                    "{type}",
                    card.card_type === "Incident" ? "incident" : "sc_task"
                  )}
                onClick={(e) => stopEvent(e, settings.header_url, card)}
                rel="noreferrer"
              >
                <span>
                  {settings.card_header === "headertext"
                    ? card.header
                    : card.number}
                </span>
              </a>
            )}
          </>
        ) : (
          <span>
            {settings.card_header === "headertext" ? card.header : card.number}
          </span>
        )}
      </>
    );

    const handleTooltipOpen = () => {
      setTooltipOpen(true);
    };
    const handleTooltipClose = () => {
      setTooltipOpen(false);
    };

    const isRightClick = (event) => {
      if (event.ctrlKey || event.metaKey) {
        return true;
      }
      return false;
    };

    const history = useHistory();

    const viewCard = (event) => {
      event.preventDefault();
      history.push({
        pathname: `/board/${boardDetails.id}`,
        search: `?cardid=${cardDetails.id}`,
      });
    };

    const getReactionState = () => {
      const emptyReactions = emptyReactionSummary();
      if (!cardDetails?.reactions) {
        return emptyReactions;
      }
      const existingCounts = cardDetails.reactions.counts;
      const existingUsersByType = cardDetails.reactions.users_by_type;
      return {
        counts: { ...emptyReactions.counts, ...existingCounts },
        users_by_type: { ...emptyReactions.users_by_type, ...existingUsersByType },
        current_user_reaction: cardDetails.reactions.current_user_reaction || null,
      };
    };

    const handleReactionClick = (reactionType) => {

      if (reactionPending || !cardDetails?.id) {
        return;
      }

      const previousReactionState = getReactionState();
      const previousSelected = previousReactionState.current_user_reaction;
      const nextSelected = previousSelected === reactionType ? null : reactionType;

      const optimisticCounts = { ...previousReactionState.counts };
      if (previousSelected && optimisticCounts[previousSelected] > 0) {
        optimisticCounts[previousSelected] = optimisticCounts[previousSelected] - 1;
      }
      if (nextSelected) {
        optimisticCounts[nextSelected] = (optimisticCounts[nextSelected] || 0) + 1;
      }

      updateCardDetailsAction(cardDetails.id, {
        reactions: {
          counts: optimisticCounts,
          users_by_type: previousReactionState.users_by_type,
          current_user_reaction: nextSelected,
        },
      });

      setReactionPending(true);

      const applyServerState = (serverResponse) => {
        const emptyReactions = emptyReactionSummary();
        const responseReactions = serverResponse?.data?.reactions || emptyReactions;
        updateCardDetailsAction(cardDetails.id, {
          reactions: {
            counts: { ...emptyReactions.counts, ...responseReactions.counts },
            users_by_type: { ...emptyReactions.users_by_type, ...responseReactions.users_by_type },
            current_user_reaction: responseReactions.current_user_reaction || null,
          },
        });
      };

      const rollbackState = () => {
        updateCardDetailsAction(cardDetails.id, {
          reactions: previousReactionState,
        });
      };

      cardService
        .toggleCardReaction({
          cardid: cardDetails.id,
          reaction_type: reactionType,
        })
        .catch(() =>
          cardService.toggleCardReaction({
            cardid: cardDetails.id,
            reaction_type: reactionType,
          })
        )
        .then((response) => {
          applyServerState(response);
        })
        .catch((retryError) => {
          rollbackState();
          const errorMessage =
            retryError?.response?.data?.message ||
            "Unable to update reaction right now. Please try again.";
          toast.error(errorMessage, errorConfig);
        })
        .finally(() => {
          setReactionPending(false);
        });
    };

    const hasReactionCounts = () => {
      const reactionState = getReactionState();
      return Object.values(reactionState.counts || {}).some((count) => count > 0);
    };

    const canReact = Boolean(
      boardDetails.userPermission &&
        boardDetails.userPermission.permission.includes("card_edit")
    );

    const openReactionMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();
      setReactionMenuAnchorEl(event.currentTarget);
    };

    const closeReactionMenu = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setReactionMenuAnchorEl(null);
    };

    return (
      <>
        <Container
          id={cardDetails.id}
          onClick={viewCard}
          className="card "
          onMouseEnter={handleTooltipOpen}
          onMouseLeave={handleTooltipClose}
        >
          <Tooltip
            title={`${cardDetails.card_type}: ${
              cardDetails.card_type === "Incident"
                ? cardDetails.short_description
                : cardDetails.task_srt
            }`}
            open={tooltipOpen}
          >
            <CardFragment>
              <CardColor
                style={{
                  background: getBGColor(
                    boardDetails.settings.card_type,
                    cardDetails.card_type
                  ),
                }}
              />
              <CardWrapper>
                {cardDetails.number && (
                  <CardHeader
                    onMouseEnter={handleTooltipClose}
                    style={{
                      background: getBGColor(
                        boardDetails.settings.card_type,
                        cardDetails.card_type
                      ),
                    }}
                  >
                    {getHeader(cardDetails, boardDetails.settings)}
                  </CardHeader>
                )}
                <CardTitle cardHeader>
                  {cardDetails.card_type === "Incident"
                    ? cardDetails.short_description
                    : cardDetails.task_srt}
                </CardTitle>
              </CardWrapper>
              <CardWrapper>
                {cardDetails.isLoading && cardDetails.statsLoading ? (
                  <Skeleton
                    variant="text"
                    height={24}
                    style={{
                      margin: "0px 6px 5px 10px",
                    }}
                  />
                ) : (
                  checkFirstMetaData && (
                    <FirstMetaContainer
                      cardDetails={cardDetails}
                      handleTooltipClose={handleTooltipClose}
                    />
                  )
                )}
              </CardWrapper>
            </CardFragment>
          </Tooltip>
        </Container>
        {(hasReactionCounts() || canReact) && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 4,
            padding: "4px 6px 2px",
            width: 240,
            minHeight: 26,
            boxSizing: "border-box",
          }}
          aria-label="Card reactions"
        >
          {hasReactionCounts() ? (
            REACTION_OPTIONS
              .filter((reaction) => (getReactionState().counts[reaction.key] || 0) > 0)
              .map((reaction) => {
                const reactionUsers = cardDetails?.reactions?.users_by_type?.[reaction.key] || [];
                const reactionUsersTitle = reactionUsers.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: 140,
                      overflowY: "auto",
                    }}
                  >
                    {reactionUsers.map((reactionUser) => (
                      <span key={reactionUser}>{reactionUser}</span>
                    ))}
                  </div>
                ) : "";
                return (
                  <Tooltip
                    key={reaction.key}
                    title={reactionUsersTitle}
                    arrow
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        background: "rgba(255,255,255,0.9)",
                        border: "1px solid rgba(0,0,0,0.15)",
                        borderRadius: 12,
                        padding: "1px 6px",
                        height: 20,
                        boxSizing: "border-box",
                        lineHeight: "16px",
                        fontSize: 11,
                        gap: 2,
                        color: "#333",
                      }}
                      aria-label={`${reaction.label} reaction. ${getReactionState().counts[reaction.key] || 0} total`}
                    >
                      <span aria-hidden="true">{reaction.emoji}</span>
                      <span style={{ marginLeft: 2 }}>
                        {getReactionState().counts[reaction.key] || 0}
                      </span>
                    </span>
                  </Tooltip>
                );
              })
          ) : null}
          {canReact && (
          <button
            type="button"
            onClick={openReactionMenu}
            disabled={reactionPending}
            aria-label="Add reaction"
            style={{
              border: "none",
              background: "none",
              padding: 0,
              height: 20,
              cursor: reactionPending ? "not-allowed" : "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={reactionEmojiAdd}
              alt=""
              aria-hidden="true"
              style={{
                width: 20,
                height: 20,
                opacity: 0.55,
                filter: "brightness(0) invert(0.55)",
              }}
            />
          </button>
          )}
        </div>
        )}
        <Menu
          open={Boolean(reactionMenuAnchorEl)}
          anchorEl={reactionMenuAnchorEl}
          onClose={closeReactionMenu}
          onClick={(event) => event.stopPropagation()}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          {REACTION_OPTIONS.map((reaction) => {
            const reactionState = getReactionState();
            const selected = reactionState.current_user_reaction === reaction.key;
            const count = reactionState.counts[reaction.key] || 0;
            return (
              <MenuItem
                key={reaction.key}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  closeReactionMenu();
                  handleReactionClick(reaction.key);
                }}
                selected={selected}
                disabled={reactionPending}
                style={{ minHeight: 32, padding: "4px 8px" }}
              >
                <span aria-hidden="true" style={{ fontSize: 20 }}>{reaction.emoji}</span>
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }
);

const mapStateToProps = (state, ownProps) => {
  const allSelectedCards = getSelectedCardsSelector(state);
  let cardDetails;
  let boardDetails;
  if (ownProps.unlink) {
    if (ownProps.parentCardBoard) {
      boardDetails = {
        id: parseInt(ownProps.boardId),
        settings: ownProps.cardDetails.boardsettings,
        userPermission: ownProps.userPermission,
      };
    } else {
      boardDetails = getBoardDetailsByBoardIdSelector(
        state,
        parseInt(ownProps.boardId)
      );
    }
    cardDetails = ownProps.cardDetails;
  } else {
    cardDetails = ownProps.cardDetails;
    boardDetails = ownProps.boardDetails;
  }
  return {
    allSelectedCards,
    cardDetails,
    boardDetails,
  };
};

const mapDispatchToProps = (dispatch, { boardId }) =>
  bindActionCreators(
    {
      onSelectCards: (list) => selectedCards(list),
      onUnselectCards: (id) => unselectCard(id),
      onSaveBoardDetails: (id, savedata) => updateBoard(parseInt(id), savedata),
      updateCardDetailsAction: (id, data) => updateCardData(id, data),
    },
    dispatch
  );

CardView.displayName = "CardView";
export default connect(mapStateToProps, mapDispatchToProps)(CardView);
